import axios from 'axios';
import toast from 'react-hot-toast';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_WALLET_API_BASE_URL || 'https://wallet.cloudvolte.com/api/wallet',
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
});

// ── Request Interceptor ────────────────────────────────────────────
apiClient.interceptors.request.use((config) => {
    // Master API key from env
    const masterKey = process.env.REACT_APP_WALLET_MASTER_API_KEY  || "Yasdj-awejm-cyute==";
    if (masterKey) {
        config.headers['x-api-key'] = masterKey;
    }

    // Wallet API key from sessionStorage (fallback to static dev value)
    const walletApiKey = sessionStorage.getItem('walletApiKey') || 'wk_2e5948486cb92d09b54368cd96334870e33b929a92d55e34';
    config.headers['x-wallet-api-key'] = walletApiKey;

    // User ID from sessionStorage (fallback to static dev value)
    const userId = sessionStorage.getItem('userId') || '5027';
    config.headers['x-user-id'] = userId;

    return config;
});

// ── Response Interceptor ───────────────────────────────────────────
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error.response?.status;

        // Rate limit handling
        if (status === 429) {
            const retryAfter = error.response.headers['retry-after'] || 5;
            toast.error(`Rate limited. Retrying in ${retryAfter}s…`);
            await new Promise((r) => setTimeout(r, retryAfter * 1000));
            return apiClient(error.config);
        }

        // Extract backend error messages
        const data = error.response?.data;
        if (data && !data.success && Array.isArray(data.errors)) {
            const msg = data.errors.map((e) => e.msg).join(', ');
            toast.error(msg || 'An error occurred');
        } else if (status === 401 || status === 403) {
            toast.error('Authentication failed. Please check your API key.');
        } else if (!error.response) {
            toast.error('Network error. Please check your connection.');
        }

        return Promise.reject(error);
    }
);

export default apiClient;
